<template>
  <div class="iframIndex">
    <iframe
      id="statistics"
      :ref="preUrl"
      :src="fullPath"
      frameborder="0"
      width="100%"
      height="100%"
    ></iframe>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import store from '@/store';
import {encrypt, addClass, removeClass} from '@/util/util'
import {base64Encode} from '@/util/endecode.js'
import hrCommon from '@/api/common/hrcloudCommon'
import router from "../../router/router";

export default {
  name: "iframCIICShared",
  data() {
    return {
      preUrl: hrCommon.HRCLOUD_URL,
      routerPath: this.$route.path,
      routerParams: this.$route.query,
      paramStr: '',
      themeType: '',
    };
  },
  computed: {
    ...mapGetters(['ygj']),
    fullPath() {
      let currentPath = this.$route.path;
      let currentFullPath = this.ygj.find(item => {
        return item.path == currentPath && item.fullPath;
      }) || {};
      return currentFullPath.fullPath;
    }
  },
  // watch: {
  //   $route: {
  //     handler: function (val, oldVal) {
  //       this.routerPath = val.path;
  //       this.routerParams = val.query;
  //     },
  //     // 深度观察监听
  //     deep: true
  //   }
  // },
  created() {
    this.themeType = this.$store.getters.themeType;
    var lang = localStorage.getItem('lang');
    if (lang) {
      lang = lang;
    } else {
      lang = "zh";
    }
    this.paramStr = 'lang=' + base64Encode(lang) + '&accessToken=' + base64Encode(encrypt(this.$store.getters.accessToken, '')) + '&themeType=' + base64Encode(this.themeType);
  },
  filters: {},
  mounted() {
    this.$nextTick(function () {
      let iframe = document.getElementById('statistics')
      var iWindow = iframe.contentWindow;
      var idoc = iWindow.document;
      addClass(document.getElementsByTagName('body')[0], 'pubIndex');
    })
  },
  destroyed() {
    removeClass(document.getElementsByTagName('body')[0], 'pubIndex');
  },
  methods: {
    getRouter: function (preUrl, routePath, routeParams, paramStr) {
      addClass(document.getElementsByTagName('body')[0], 'pubIndex');
      if (routeParams) {
        let routeParamStr = "";
        for (let key in routeParams) {
          routeParamStr += "&" + key + "=" + routeParams[key]
        }
        return preUrl + routePath + "?" + routeParamStr;
      } else {
        return preUrl + routePath;
      }
      return "";
    }
  }
}
</script>

<style scoped>
    .iframIndex{
        height: 100%;
        box-sizing: border-box;
    }
</style>
